import { render } from "./WorkspaceSchedulationTable.vue?vue&type=template&id=30ac4caa&scoped=true&ts=true"
import script from "./WorkspaceSchedulationTable.vue?vue&type=script&lang=ts"
export * from "./WorkspaceSchedulationTable.vue?vue&type=script&lang=ts"

import "./WorkspaceSchedulationTable.vue?vue&type=style&index=0&id=30ac4caa&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ac4caa"]])

export default __exports__